/**
 * Fantasy Console 0 - SFX Settings Component
 *
 * Number inputs for speed, loop start, and loop end.
 * Quick-set buttons for loop configuration.
 */

import type { SFX } from '@fc0/types'
import { NOTES_PER_SFX } from '@fc0/types'
import styles from './SFXSettings.module.css'

interface SFXSettingsProps {
  speed: number
  loopStart: number
  loopEnd: number
  onSfxPropsChange: (
    props: Partial<Pick<SFX, 'speed' | 'loop_start' | 'loop_end'>>,
  ) => void
}

export function SFXSettings({
  speed,
  loopStart,
  loopEnd,
  onSfxPropsChange,
}: SFXSettingsProps) {
  const handleLoopAll = () => {
    onSfxPropsChange({ loop_start: 0, loop_end: NOTES_PER_SFX - 1 })
  }

  const handleNoLoop = () => {
    onSfxPropsChange({ loop_start: 0, loop_end: 0 })
  }

  return (
    <div className={styles.container}>
      <div className={styles.field}>
        <label className={styles.label}>Speed</label>
        <input
          type='number'
          className={styles.input}
          value={speed}
          min={1}
          max={255}
          onChange={(e) =>
            onSfxPropsChange({
              speed: Math.max(1, Math.min(255, parseInt(e.target.value) || 1)),
            })
          }
        />
      </div>
      <div className={styles.field}>
        <label className={styles.label}>Loop Start</label>
        <input
          type='number'
          className={styles.input}
          value={loopStart}
          min={0}
          max={31}
          onChange={(e) =>
            onSfxPropsChange({
              loop_start: Math.max(
                0,
                Math.min(31, parseInt(e.target.value) || 0),
              ),
            })
          }
        />
      </div>
      <div className={styles.field}>
        <label className={styles.label}>Loop End</label>
        <input
          type='number'
          className={styles.input}
          value={loopEnd}
          min={0}
          max={31}
          onChange={(e) =>
            onSfxPropsChange({
              loop_end: Math.max(
                0,
                Math.min(31, parseInt(e.target.value) || 0),
              ),
            })
          }
        />
      </div>
      <div className={styles.loopButtons}>
        <button
          className={styles.quickButton}
          onClick={handleLoopAll}
          title='Set loop to cover all notes'
        >
          Loop All
        </button>
        <button
          className={styles.quickButton}
          onClick={handleNoLoop}
          title='Disable loop'
        >
          No Loop
        </button>
      </div>
    </div>
  )
}
